import {BasicEntity} from '../../framework/message/BasicEntity';
import {Domain} from '../../domain/message/Domain';
import {Role} from './Role';
import {Tab} from '../../../allkeyme/workingdata/message/Tab';
import {UserApplication} from './UserApplication';
import {UserDynamicFeature} from './UserDynamicFeature';

export class User extends BasicEntity {
active: boolean | null;
domains: Domain[];
dynamicFeatures: UserDynamicFeature[];
firstname: string;
genderCode: string;
lastname: string;
locked: boolean | null;
lockedOn: number | null;
mail: string;
managerLogin: string;
newPassword: string;
notifyUser: boolean | null;
roles: Role[];
tabs: Tab[];
tags: Object;
titleCode: string;
userApplications: UserApplication[];
}

